'use client';
import {
  Button,
  Container,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useEffect } from 'react';
import Optional from '@jd/ui/components/Optional';
import { useTranslate } from '@jd/i18n';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslate('common.errorPage');
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Container maxWidth={'md'} sx={{ height: '100%' }}>
      <Paper sx={{ p: 2, margin: 'auto', mt: '40%' }}>
        <Stack spacing={2} sx={{ alignItems: 'center' }}>
          <ErrorIcon sx={{ fontSize: '72px' }} color={'error'} />
          <Typography variant={'h4'}>{t('title')}</Typography>
          <Optional condition={!!error.digest}>
            <Typography variant={'body2'}>
              {t('errorId', { id: `${error.digest}` })}
            </Typography>
          </Optional>
          <Button variant={'outlined'} onClick={() => reset()}>
            {t('tryAgain')}
          </Button>
          <Typography>
            {t('goBack')}{' '}
            <Link sx={{ textDecoration: 'underline' }} href="/">
              {t('homePage')}
            </Link>
          </Typography>
        </Stack>
      </Paper>
    </Container>
  );
}
